<template>
  <div
    id="app"
    class="app container"
  >
    <navbar />
    <div class="row">
      <tree
        :hooks="hooks"
        class="col-3"
      />
      <div class="col p-2">
        <h1>Хуки</h1>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../../components/Navbar.vue'
import Tree from '../../components/Tree.vue'


export default {
  name: 'Index',
  components: {
    Navbar,
    Tree,
  },
  props: {
    hooks: { type: Array, required: true },
  },
}
</script>
